import { module } from 'angular';

import { default as directoryServiceName, DirectoryService } from './directory.service';
import { default as searchServiceName, SearchService } from './search.service';

export default module('contact.agent.core.search', [])
  .service(directoryServiceName, DirectoryService)
  .service(searchServiceName, SearchService).name;
